import script from "./MediaContent.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaContent.vue?vue&type=script&setup=true&lang=js"

import "./MediaContent.vue?vue&type=style&index=0&id=7ff73811&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff73811"]])

export default __exports__